<template>
  <div class="wrapper">
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <notifications></notifications>
    <parallax
      class="page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"></div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section pb-0 pt-0">
        <div class="container">
          <md-card class="md-card-plain">
            <md-card-content>
              <h3 class="card-title">{{labels.shopcart}}</h3>
              <div class="text-center: center" v-if="order.total === 0">
                <h2>{{labels.cartempty}}</h2>
              </div>
              <div
                class="md-layout vertical-center padding-bottom-20"
                :key="item.id + item.priceid"
                v-for="item in order.details"
              >
                <div class="md-layout-item md-size-15 md-small-size-100">
                  <div class="img-container">
                    <img :src="fileurl + item.picture" alt="products" />
                  </div>
                </div>
                <div class="md-layout-item md-size-35 md-small-size-100 text-center">
                  <h3 class="title">{{ item.title }}</h3>
                  <span style="font-size: 16px">{{ item.spec }}</span>
                </div>
                <div class="md-layout-item md-size-10 md-small-size-100 text-center">
                  <span class="shop-card-title">{{labels.price}}</span>
                  <h4>
                    <small>₼</small>
                    {{ item.price }}
                  </h4>
                </div>
                <div class="md-layout-item md-size-20 md-small-size-100 text-center">
                  <span class="shop-card-title">{{labels.count}}</span>
                  <h4>
                    {{ item.count }}
                    <div class="md-group">
                      <md-button class="md-round md-info md-sm" @click="increaseQuantity(item)">
                        <md-icon>add</md-icon>
                      </md-button>
                      <md-button class="md-round md-info md-sm" @click="decreaseQuantity(item)">
                        <md-icon>remove</md-icon>
                      </md-button>
                    </div>
                  </h4>
                </div>
                <div class="md-layout-item md-size-10 md-small-size-100 text-center">
                  <span class="shop-card-title">{{labels.amount}}</span>
                  <h4>
                    <small>₼</small>
                    {{ item.amount }}
                  </h4>
                </div>
                <div class="md-layout-item md-size-10 md-small-size-100 text-center">
                  <md-button class="md-just-icon md-round md-danger" @click="remove(item)">
                    <md-icon>close</md-icon>
                  </md-button>
                </div>
              </div>
              <div class="table table-stats">
                <div class="td-price" v-if="order.total > 0">
                  <div class="td-total">{{labels.total}}</div>
                  <span>
                    <small>₼</small>
                    {{ $store.state.order.total }}
                  </span>
                </div>
                <div class="text-right">
                  <md-button
                    @click="$router.push({ path: '/' + id })"
                    class="md-simple md-success"
                  >{{labels.continueshop}}</md-button>
                  <md-button
                    v-if="order.total > 0"
                    class="md-info md-round"
                    :disabled="$store.state.order.total === 0"
                    @click="$router.push({ path: '/order/' + id })"
                  >
                    {{labels.finish}}
                    <md-icon>keyboard_arrow_right</md-icon>
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Mixins from "@/plugins/basicMixins";
import { fileUrl, nophoto, Round2 } from "../services/helper";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  props: { id: String },
  components: {
    Loading
  },
  mixins: [Mixins.HeaderImage],
  computed: {
    ...mapState({
      order: state => state.order,
      bkg: state => state.menubkg
    }),
    fileurl() {
      return fileUrl;
    },
    image() {
      return this.bkg ? this.fileurl + this.bkg : "";
    }
  },
  data() {
    return {
      nophoto: nophoto,
      isLoading: false,
      labels: {
        name: this.localeLabel("name"),
        price: this.localeLabel("price"),
        total: this.localeLabel("total"),
        count: this.localeLabel("count"),
        amount: this.localeLabel("amount"),
        continueshop: this.localeLabel("continueshop"),
        gotobasket: this.localeLabel("gotobasket"),
        shopcart: this.localeLabel("shopcart"),
        finish: this.localeLabel("finish"),
        cartempty: this.localeLabel("cartempty")
      }
    };
  },
  methods: {
    increaseQuantity(item) {
      item.count++;
      this.computeAmount(item);
    },
    decreaseQuantity(item) {
      if (item.count > 1) {
        item.count--;
        this.computeAmount(item);
      }
    },
    computeAmount(item) {
      let res = item.count * item.price;
      item.amount = Round2(res);
      this.$store.dispatch("updateItemCount", item);
    },
    remove(item) {
      this.$store.dispatch("removeItem", item);
    }
  },
  created() {
    this.$store.dispatch("fetchMenuBkg", this.id);
  }
};
</script>

<style lang="scss">
.table-stats {
  display: flex;
  align-items: center;
  text-align: right;
  flex-flow: row wrap;

  .td-price .td-total {
    display: inline-flex;
    font-weight: 500;
    font-size: 1.0625rem;
    margin-right: 50px;
  }

  .td-price {
    font-size: 26px;
    border-top: 1px solid #ddd;
  }

  .td-price,
  > div {
    flex: 0 0 100%;
    padding: 12px 8px;
  }
}
.text-center {
  text-align: center;
}
.vertical-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.padding-bottom-20 {
  padding-bottom: 20px;
}
@media only screen and (max-width: 600px) {
  .grid-title {
    display: none;
  }
  .shop-card-title {
    font-weight: bold;
    display: block;
  }
}
@media screen and (min-width: 601px) {
  .grid-title {
    display: block;
  }
  .shop-card-title {
    display: none;
  }
}
</style>
